import { isGlobalAdmin } from './roles';

export const getStoredAuthUser = () => {
  try {
    const token = window.localStorage.getItem('auth_token');
    if (!token) return null;
    const raw = window.localStorage.getItem('auth_user');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

export const hasAccessConfig = item => {
  if (!item) return false;
  if (item.owner) return true;
  const access = item.access;
  if (!access || typeof access !== 'object') return false;
  return (
    Array.isArray(access.admins) ||
    Array.isArray(access.editors) ||
    Array.isArray(access.readers) ||
    typeof access.visibility === 'string' ||
    typeof access.defaultRole === 'string'
  );
};

export const isUserInList = (list, userId) => {
  if (!userId || !Array.isArray(list)) return false;
  return list.some(entry => entry?.toString?.() === userId);
};

export const isUniverseAdmin = (universe, userId) => {
  if (!universe || !userId) return false;
  if (universe.owner && universe.owner.toString?.() === userId) return true;
  return isUserInList(universe?.access?.admins, userId);
};

export const isUniverseAdminForItem = (item, items, userId) => {
  if (!item) return false;
  const universe = item.type === 'universe' ? item : items?.[item.universe];
  return isUniverseAdmin(universe, userId);
};

export const getCampaignRoleForItem = (item, items, userId) => {
  if (!item || !userId) return null;
  const campaign =
    item.type === 'campaign' ? item : items?.[item.campaign] ?? null;
  if (!campaign) return null;
  if (isUserInList(campaign?.access?.admins, userId)) return 'admin';
  if (isUserInList(campaign?.access?.editors, userId)) return 'editor';
  if (isUserInList(campaign?.access?.readers, userId)) return 'reader';
  return null;
};

export const isCampaignAdminForItem = (item, items, userId) => {
  return getCampaignRoleForItem(item, items, userId) === 'admin';
};

export const canUseMjForItem = (item, items) => {
  if (!item) return false;
  if (isGlobalAdmin()) return true;
  const authUser = getStoredAuthUser();
  const authUserId = authUser?._id;
  return (
    isUniverseAdminForItem(item, items, authUserId) ||
    isCampaignAdminForItem(item, items, authUserId)
  );
};

export const isMjForItem = (item, items) => {
  const mjAccess = window.localStorage.getItem('mj_access');
  if (!mjAccess || !item) return false;
  if (item?.password && item.password === mjAccess) {
    return true;
  }
  const universe = item?.type === 'universe' ? item : items?.[item?.universe];
  if (!universe) return false;
  return universe?.password === mjAccess;
};
